// The vault path breadcrumb for the shell header: <VaultName> › <folder…> ›
// <file>. The vault name is the root — a link back to the vault's own view when
// a file is open, or the current page at the vault root. Folder segments are
// plain (no folder route); the file is the current page. There's no "Vaults"
// crumb above it: the sidebar is the vault list (decisions/90).

import { Fragment } from "react";
import { Link } from "react-router-dom";
import { displayName } from "../wikiLinks";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";

export function VaultBreadcrumbs({
  vaultId,
  vaultName,
  path,
}: {
  vaultId: string;
  vaultName: string;
  path: string;
}) {
  const segs = path ? path.split("/") : [];
  return (
    <Breadcrumb>
      <BreadcrumbList>
        <BreadcrumbItem>
          {segs.length === 0 ? (
            <BreadcrumbPage className="max-w-56 truncate">{vaultName}</BreadcrumbPage>
          ) : (
            <BreadcrumbLink render={<Link to={`/v/${vaultId}`} />} className="max-w-40 truncate">
              {vaultName}
            </BreadcrumbLink>
          )}
        </BreadcrumbItem>
        {segs.map((seg, i) => {
          const last = i === segs.length - 1;
          return (
            <Fragment key={i}>
              <BreadcrumbSeparator />
              <BreadcrumbItem>
                {last ? (
                  <BreadcrumbPage className="max-w-56 truncate">
                    {displayName(seg)}
                  </BreadcrumbPage>
                ) : (
                  <span className="max-w-40 truncate text-muted-foreground">{seg}</span>
                )}
              </BreadcrumbItem>
            </Fragment>
          );
        })}
      </BreadcrumbList>
    </Breadcrumb>
  );
}
